import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { DxDropDownBoxComponent } from 'devextreme-angular';
import { bookIcon, minusCircleIcon, warningIcon } from 'src/app/app-icons';
import { EventVisibilityModeModel } from 'src/app/models/event-visibility-mode.model';
import { OrganisationUnitModel } from 'src/app/models/organisation-unit/organisation-unit.model';
import { RoleModel } from 'src/app/models/person/role.model';
import { StandardTrainingCategoryViewModel } from 'src/app/models/standard-training-category/standard-training-category-view.model';
import { TenantSubscriberModel } from 'src/app/models/subscription/tenant-subscriber.model';
import { TrainingCategoryModel } from 'src/app/models/training-category/training-category.model';
import { TrainingGroupModel } from 'src/app/models/training-group.model';

@Component({
  selector: 'app-publish-to-catalogue-section',
  standalone: false,
  templateUrl: './publish-to-catalogue-section.component.html',
  styleUrl: './publish-to-catalogue-section.component.scss',
})
export class PublishToCatalogueSectionComponent {
  @Input() isViewMode = false;
  @Input() isCourse = false;

  @Input() visibilityMode: EventVisibilityModeModel = 
      EventVisibilityModeModel.Everyone;
  
  @Input() organizationUnits: OrganisationUnitModel[] = [];
  @Input() trainingGroups: TrainingGroupModel[] = [];
  @Input() trainingCategories: TrainingCategoryModel[] = [];

  @Input() organisationUnitIds: string[] = [];
  @Input() trainingGroupIds: string[] = [];
  @Input() trainingCategoryIds: string[] = [];

  @Input() personCount = 0;

  @Output() visibilityModeChange = new EventEmitter<EventVisibilityModeModel>();
  @Output() organisationUnitIdsChange = new EventEmitter<string[]>();
  @Output() trainingGroupIdsChange = new EventEmitter<string[]>();
  @Output() trainingCategoryIdsChange = new EventEmitter<string[]>();
  
  constructor(
    private translateService: TranslateService,
    private sanitizer: DomSanitizer
  ) {}

  onTrainingCategorySelected(e: any): void {
    if (e.node.selected) {
      this.trainingCategoryIds = [
        ...this.trainingCategoryIds,
        e.node.key,
      ];
    } else {
      this.trainingCategoryIds =
        this.trainingCategoryIds.filter(id => id !== e.node.key);
    }

    this.trainingCategoryIdsChange.emit(this.trainingCategoryIds);
  }

  onVisibilityModeChanged(
    mode: EventVisibilityModeModel
  ): void {
    this.visibilityMode = mode;
    this.visibilityModeChange.emit(mode);
  }

  onOrganisationUnitIdsChanged(ids: string[]): void {
    this.organisationUnitIds = ids;
    this.organisationUnitIdsChange.emit(ids);
  }

  onTrainingGroupIdsChanged(ids: string[]): void {
    this.trainingGroupIds = ids;
    this.trainingGroupIdsChange.emit(ids);
  }

  getTrainingCatalogueText(): string {
    const categories = this.trainingCategories
      .filter(x => this.trainingCategoryIds.includes(x.id))
      .map(x => x.name);

     return this.translateService.instant(
      this.isCourse 
        ? 'CATALOGUE.ELEARNING.VISIBLE-TO-EVERYONE'
        : 'CATALOGUE.TRAINING.VISIBLE-TO-EVERYONE',
      {
        categories: categories.join(', ')
      }
    );
  }

  getBookIcon() {
    return this.sanitizer.bypassSecurityTrustHtml(bookIcon);
  }

  getWarningIcon() {
    return this.sanitizer.bypassSecurityTrustHtml(warningIcon);
  }
}
